// Prezzo tessera (stessa logica del server): rivenditore > prezzo fisso Silver/Gold > % brand dal listino > % default sul prezzo
export const normBrand = (b) => (b || "").toString().trim().toLowerCase().replace(/\s+/g, " ");
export const DEFAULT_PCT = { silver_pct: 10, gold_pct: 15 };
export const NO_TIER_CATEGORIES = new Set(["keto", "food", "barrette"]);
const round2 = (v) => Math.round(v * 100) / 100;

export const brandPct = (product, tier, rows) => {
  if (tier !== "silver" && tier !== "gold") return 0;
  if (NO_TIER_CATEGORIES.has((product?.category || "").toLowerCase().trim())) return 0;
  const row = (rows || []).find((r) => normBrand(r.brand) === normBrand(product?.brand));
  return row && Number(row[`${tier}_pct`]) > 0 ? Number(row[`${tier}_pct`]) : 0;
};

// { price, source: "reseller" | "fixed" | "brand" | "default" | null, pct }
export const tierPriceInfo = (product, unit, tier, rows, resellerPrices) => {
  const rp = resellerPrices?.[product?.product_id];
  if (resellerPrices && rp) return { price: round2(Math.min(unit, rp)), source: "reseller", pct: 0 };
  if (tier !== "silver" && tier !== "gold") return { price: unit, source: null, pct: 0 };
  const fixed = Number(product?.[`${tier}_price`] || 0);
  if (fixed > 0) return { price: round2(Math.min(unit, fixed)), source: "fixed", pct: 0 };
  if (NO_TIER_CATEGORIES.has((product?.category || "").toLowerCase().trim())) return { price: unit, source: null, pct: 0 };
  const pct = brandPct(product, tier, rows);
  if (pct > 0) {
    const base = Number(product?.compare_at_price || 0) || unit;
    return { price: round2(Math.min(unit, base * (1 - pct / 100))), source: "brand", pct };
  }
  const dp = DEFAULT_PCT[`${tier}_pct`];
  return { price: round2(unit * (1 - dp / 100)), source: "default", pct: dp };
};

export const tierUnitPrice = (product, unit, tier, rows, resellerPrices) => tierPriceInfo(product, unit, tier, rows, resellerPrices).price;

export const computeTierDiscount = (items, tier, rows, { unitFn, skipCategories = [], resellerPrices } = {}) => {
  const skip = new Set(skipCategories.map((c) => c.toLowerCase()));
  return items.reduce((sum, it) => {
    if (skip.has((it.category || "").toLowerCase())) return sum;
    const unit = unitFn ? unitFn(it) : Number(it.price);
    return sum + (unit - tierUnitPrice(it, unit, tier, rows, resellerPrices)) * (it.quantity || 1);
  }, 0);
};

export const brandLabel = (rows, tier) => {
  const brands = (rows || []).filter((r) => Number(r[`${tier}_pct`]) > 0).map((r) => `${r.brand} -${Number(r[`${tier}_pct`])}%`);
  return [...brands, `altri marchi -${DEFAULT_PCT[`${tier}_pct`]}%`].join(" · ");
};
